import { Box, Button, Checkbox, CloseButton, ColorInput, Divider, Grid, Group, Image, NumberInput, PasswordInput, Select, Switch, Tabs, Text, TextInput, Textarea, rem } from "@mantine/core";
import Modal, { Props as ModalProps } from "./Modal";
import { useForm } from "@mantine/form";
import { useEffect, useState } from "react";
import { client } from "../../lib/axiosClient";
import { IconCheck, IconPhoto, IconUpload, IconX, IconXboxX } from "@tabler/icons-react";
import { zodResolver } from 'mantine-form-zod-resolver';
import { z } from 'zod';
import { notifications } from "@mantine/notifications";

import Cookies from "universal-cookie";
import { useTranslation } from "react-i18next";
import Wilayas from '../../helper/wilayas.json';
import { useStore } from "../../api";

const cookies = new Cookies(null, { path: '/' });
type Props = {
    data?: any;
    refetchData?: () => void;
} & ModalProps;

export const UpdateClient = (props: Props) => {
    const { t } = useTranslation();
    
    const schema = z.object({
        name: z.string({message: "اسم العميل اجباري"}).min(2, { message: "اسم العميل يجب ان يكون اطول من حرفين" }),
        phone: z.string({message: "رقم الهاتف اجباري"}).min(9, { message: "رقم الهاتف يجب ان يكون 10 ارقام" }).max(10, { message: "رقم الهاتف يجب ان يكون 10 ارقام" }),
        email: z.string({message: "البريد الالكتروني اجباري"}).min(2, { message: "البريد الالكتروني يجب ان يكون اطول من حرفين" }),
    });
    const [loading, setLoading] = useState(false);
    const {onSubmit, reset, getInputProps, setValues, values} = useForm({
        initialValues: { name: "", phone: "", email: "", theme: "nova", version: "basic"},
        validate: zodResolver(schema),
        validateInputOnBlur: true,
        validateInputOnChange: true
    });

    useEffect(() => {
        if (props.opened && props.data !== null) {
            const client = props.data
            setValues({
                name: client?.name,
                phone: client?.phone,
                email: client?.email,
                theme: client?.theme,
                version: client?.version,
            })
        }
    }, [props.opened, props?.data])

    const onSubmitForm = ({name, phone, email, theme, version}: any) => {
        setLoading(true)
        
        client.put(`/clients/${props.data._id}`, {name, phone, email, theme, version}, {
            headers: {
                'Accept': 'application/json',
                'Authorization': cookies.get('token') || ""
            }
        })
        .then(({data}) => {
            notifications.show({ message: "تم تعديل العميل", color: '#fff' });
            console.log(data);
            setLoading(false)
            typeof props.refetchData == "function" && props.refetchData()
            closeModal()
        })
        .catch(({response}) => {
            notifications.show({ message: "فشل تعديل العميل", color: '#fff' });
            setLoading(false)
        });
    }

    const closeModal = () => {
        reset();
        props.onClose();
        setLoading(false)
    };

    return (
        <Modal
            {...props} onClose={closeModal} loading={loading}
            footer={
                <Box py={16} px={20} bg="slate.0">
                    <Group justify={"flex-end"} gap={"xs"}>
                        <Button color={'gray'} variant="outline" rightSection={<IconX size={15} />} bg="white" onClick={closeModal}>{t('modals.cancelling')}</Button>
                        <Button color={'#323232'} rightSection={<IconCheck size={15} />} type="submit" form="submit_form">{t('modals.confirmation')}</Button>
                    </Group>
                </Box>
            }
        >
            <Box style={{padding: 20}}>
                <form onSubmit={onSubmit(onSubmitForm)} id="submit_form">
                    <Grid gutter={20} justify="flex-start">
                        <Grid.Col span={6} >
                            <TextInput
                                label={"اسم العميل"}
                                placeholder={"اسم العميل"}
                                withAsterisk
                                {...getInputProps("name")}
                            />
                        </Grid.Col>
                        <Grid.Col span={6} >
                            <TextInput
                                label={"رقم الهاتف"}
                                placeholder={"رقم الهاتف"}
                                withAsterisk
                                {...getInputProps("phone")}
                            />
                        </Grid.Col>
                        <Grid.Col span={6} >
                            <TextInput
                                label={"البريد الالكتروني"}
                                placeholder={"البريد الالكتروني"}
                                withAsterisk
                                {...getInputProps("email")}
                            />
                        </Grid.Col>
                        <Grid.Col span={6} >
                            <Select
                                label={"الثيم"}
                                placeholder={"الثيم"}
                                data={[
                                    {label: "Nova", value: "nova"},
                                    {label: "Solo", value: "solo"},
                                    {label: "Nexa", value: "nexa"},
                                    {label: "Anaqati", value: "anaqati"}
                                ]}
                                withAsterisk
                                {...getInputProps("theme")}
                            />
                        </Grid.Col>
                        <Grid.Col span={6} >
                            <Select
                                label={"الخطة"}
                                placeholder={"الخطة"}
                                data={[
                                    {label: "الخطة البسيطة", value: "basic"},
                                    {label: "الخطة الاحترافية", value: "pro"},
                                    {label: "الخطة المخصصة", value: "custom"}
                                ]}
                                withAsterisk
                                allowDeselect={false}
                                {...getInputProps("version")}
                            />
                        </Grid.Col>
                    </Grid>
                </form>
            </Box>
        </Modal>
    );
};